import { Locale } from 'interfaces/language';
import { formatDateByUserLocale } from 'utils/date/formatDateByUserLocale';

interface Parameters {
  loadingSubscription: boolean;
  nextPaymentDate: Date;
  userLocale: Locale;
}

export function formatNextPaymentDate({
  loadingSubscription,
  nextPaymentDate,
  userLocale,
}: Parameters): string | void {
  if (!loadingSubscription && nextPaymentDate) {
    return formatDateByUserLocale(nextPaymentDate, userLocale);
  }
}
